export function hasProjectLeadAssociation(project: any): boolean {
  if (!project) return false;

  const rawLeadId = project.leadId;
  const hasLeadId =
    rawLeadId !== null &&
    rawLeadId !== undefined &&
    rawLeadId !== '' &&
    rawLeadId !== 0 &&
    rawLeadId !== '0';

  if (hasLeadId) return true;

  const lead = project.lead;
  if (!lead) return false;

  if (typeof lead === 'object') {
    return Object.keys(lead).length > 0;
  }

  return true;
}

export function isProjectAssociatedToLead(
  project: any,
  leadId?: number | string | null,
): boolean {
  if (leadId === null || leadId === undefined || leadId === '') return false;

  const normalizedLeadId = Number(leadId);
  if (!Number.isFinite(normalizedLeadId) || normalizedLeadId <= 0) return false;

  const projectLeadId = Number(project?.leadId);
  if (Number.isFinite(projectLeadId) && projectLeadId === normalizedLeadId) {
    return true;
  }

  const lead = project?.lead;
  const nestedLeadId = Number(lead?.id ?? lead?.originalId);

  return Number.isFinite(nestedLeadId) && nestedLeadId === normalizedLeadId;
}

export function isProjectAvailableForOpportunity(
  project: any,
  currentLeadId?: number | string | null,
): boolean {
  return (
    !hasProjectLeadAssociation(project) ||
    isProjectAssociatedToLead(project, currentLeadId)
  );
}
